<script>
export default {
  name: "PreviewImg",
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 50
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: "fill"
    },
    length: {
      type: Number,
      default: null
    }
  },
  computed: {
    picUrlList() {
      const list = this.imgUrl ? this.imgUrl.split(",") : [];
      return list.map(item => {
        // 判断如果是http/https 直接返回
        if (item.startsWith("http://") || item.startsWith("https://")) return item;
        return this.$api.file.downloadImg + item
      });
    },

    style() {
      if(this.width && this.height) {
        return {
          width: this.width,
          height: this.height
        }
      }
      return {"--size": this.size + "px"}
    },
    showMore() {
      if(!this.length) return false;
      return this.picUrlList.length > this.length;
    }
  },
}
</script>

<template>
  <div class="img-row">
    <template v-for="(item, index) in picUrlList">
      <el-image
          v-if="index < (length || picUrlList.length)"
          :fit="fit"
          :style="style"
          :key="index"
          :src="item"
          :preview-src-list="picUrlList" />
    </template>
    <span v-if="showMore">…</span>
  </div>
</template>

<style scoped>

.img-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.el-image {
  width: var(--size);
  height: var(--size);
}

</style>
